/**
 * ActionNode - Modern action node
 */

import { memo } from 'react';
import { Handle, Position } from '@xyflow/react';
import { ICON_MAP } from '../../constants/iconMap';

const ActionNode = ({ data, selected }) => {
  // Resolve o ícone APENAS pelo ICON_MAP (não usar data.icon que não pode ser serializado)
  const Icon = ICON_MAP[data.iconKey] || ICON_MAP[data.key];

  return (
    <div className={`afc-node afc-node-action ${selected ? 'selected' : ''}`}>
      <Handle
        type="target"
        position={Position.Top}
        className="afc-handle afc-handle-target"
      />

      <div className="afc-node-accent" style={{ background: data.gradient }} />

      <div className="afc-node-inner">
        <div className="afc-node-icon-wrapper" style={{ background: data.gradient }}>
          {Icon && <Icon size={18} stroke={1.5} />}
        </div>
        <div className="afc-node-text">
          <span className="afc-node-label">{data.label}</span>
          <span className="afc-node-type-badge action">Ação</span>
        </div>
      </div>

      <Handle
        type="source"
        position={Position.Bottom}
        className="afc-handle afc-handle-source"
      />
    </div>
  );
};

export default memo(ActionNode);
